import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M19 22H5C4.44772 22 4 21.5523 4 21V11.357C4.01549 11.1119 4.11964 10.8809 4.293 10.707L11.293 3.70698C11.4806 3.51921 11.7351 3.4137 12.0005 3.4137C12.2659 3.4137 12.5204 3.51921 12.708 3.70698L19.708 10.707C19.8957 10.8943 20.0009 11.1488 20 11.414V21C20 21.5523 19.5523 22 19 22ZM12 5.82798L6 11.828V20H18V11.828L12 5.82798ZM13 17.999H11V14.999H8V12.999H11V9.99898H13V12.999H16V14.999H13V17.999Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "HomeAltPlus"
);
